/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import client from "./client";

export const listFavorites = async () => {
  const { data } = await client.get("/drive/favorites");
  return { files: data.files || [], folders: data.folders || [] };
};

/**
 * Just the ids, so a folder listing can mark stars with one extra request
 * rather than one per row.
 */
export const listFavoriteIds = async () => {
  const { data } = await client.get("/drive/favorites/ids");
  return new Set([...(data.file_ids || []), ...(data.folder_ids || [])]);
};

export const setFavorite = async ({ resourceType, resourceId, favorited }) => {
  const body = { resource_type: resourceType, resource_id: resourceId };
  // DELETE with a body is unusual but matches the API, which treats the pair
  // as the identifier rather than putting it in the path.
  if (favorited) await client.post("/drive/favorites", body);
  else await client.delete("/drive/favorites", { data: body });
  return favorited;
};
